import {Select} from "element-ui";

Select.props.popperAppendToBody = {
    type:Boolean,
    default:false
}

export default Select;